import React from 'react';

import Hero from '../components/hero';
import ServiceListing from '../components/service-listing';
import Contact from '../components/contact';

const IndexPage = () => (
  <main id="main-content" className="container-fluid">
    <Hero />
    <ServiceListing />
    <Contact />
  </main>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js